import {
  AudienceUpdateMutation,
  AudienceUpdateMutationVariables,
  useAudienceUpdateMutation as useApolloAudienceUpdateMutation,
  AudienceCreateMutation,
  AudienceCreateMutationVariables,
  useAudienceCreateMutation as useApolloAudienceCreateMutation,
  AudienceDeleteMutation,
  AudienceDeleteMutationVariables,
  useAudienceDeleteMutation as useApolloAudienceDeleteMutation,
  AudienceActivateMutation,
  AudienceActivateMutationVariables,
  useAudienceActivateMutation as useApolloAudienceActivateMutation,
  AudienceUpdateMutationOptions,
  AudienceCreateMutationOptions,
  AudienceDeleteMutationOptions,
  AudienceActivateMutationOptions,
  ReportAudienceStartGenerationJobMutationOptions,
  ReportAudienceStartGenerationJobMutation,
  ReportAudienceStartGenerationJobMutationVariables,
  useReportAudienceStartGenerationJobMutation,
  MarkAudienceForSizeCalculationMutationOptions,
  MarkAudienceForSizeCalculationMutation,
  MarkAudienceForSizeCalculationMutationVariables,
  useMarkAudienceForSizeCalculationMutation as useApolloMarkAudienceForSizeCalculationMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useAudienceUpdateMutation = (baseOptions: AudienceUpdateMutationOptions) =>
  useMutation<AudienceUpdateMutation, AudienceUpdateMutationVariables>(
    useApolloAudienceUpdateMutation,
    baseOptions,
  );

export const useAudienceCreateMutation = (baseOptions: AudienceCreateMutationOptions) =>
  useMutation<AudienceCreateMutation, AudienceCreateMutationVariables>(
    useApolloAudienceCreateMutation,
    baseOptions,
  );

export const useAudienceDeleteMutation = (baseOptions: AudienceDeleteMutationOptions) =>
  useMutation<AudienceDeleteMutation, AudienceDeleteMutationVariables>(
    useApolloAudienceDeleteMutation,
    baseOptions,
  );

export const useAudienceActivateMutation = (baseOptions: AudienceActivateMutationOptions) =>
  useMutation<AudienceActivateMutation, AudienceActivateMutationVariables>(
    useApolloAudienceActivateMutation,
    baseOptions,
  );

export const useAudienceExportMutation = (
  baseOptions: ReportAudienceStartGenerationJobMutationOptions,
) =>
  useMutation<
    ReportAudienceStartGenerationJobMutation,
    ReportAudienceStartGenerationJobMutationVariables
  >(useReportAudienceStartGenerationJobMutation, baseOptions);

export const useMarkAudienceForSizeCalculation = (
  baseOptions?: MarkAudienceForSizeCalculationMutationOptions,
) =>
  useMutation<
    MarkAudienceForSizeCalculationMutation,
    MarkAudienceForSizeCalculationMutationVariables
  >(useApolloMarkAudienceForSizeCalculationMutation, baseOptions);
